import { render, staticRenderFns } from "./team-members.vue?vue&type=template&id=4ea065b3&scoped=true&"
import script from "./team-members.vue?vue&type=script&lang=js&"
export * from "./team-members.vue?vue&type=script&lang=js&"
import style0 from "./team-members.vue?vue&type=style&index=0&id=4ea065b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea065b3",
  null
  
)

component.options.__file = "team-members.vue"
export default component.exports